import { Field, FieldArray, Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import { Col, Divider, Row, Space, Tag, Switch as AntdSwitch, Modal } from "antd";
import { Button } from "components/elements";
import { InputNumber, RadioGroup, Select, Switch } from "components/form";

import { CloseOutlined, DeleteOutlined, PlusCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { Checkbox, ConfigProvider } from "antd/lib";
import { initialValues as INITIAL_VALUES } from "../schemas/leaveTypeEntitlementSchema";
import styles from "../styles/LeaveType.module.css";
import { useSelector } from "react-redux";



function LeaveTypeEntitlementForm({
  initialValues = {},
  initialEntitlement = {},
  positionOptions = [],
  onCancel = () => { },
  onSubmit = () => { },
  onSubmitLeaveEntitlement = () => { },
  type
}) {
  const { roles } = useSelector((state) => state.company);
  const { t, i18n } = useTranslation();
  const tagRender = (props) => {
    const { label, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable={false}
        onClose={onClose}
        style={{
          border: "1px solid var(--font, #2BA4DD)",
          borderRadius: "59px",
          marginRight: 3,
          color: "var(--font, #2BA4DD)",
          display: "flex",
          alignItems: "center",
          padding: "4px 8px",
        }}
      >
        {label}
        <CloseOutlined style={{ marginLeft: 4 }} onClick={onClose} />
      </Tag>
    );
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{ ...INITIAL_VALUES, ...initialEntitlement }}
      onSubmit={onSubmitLeaveEntitlement}
    // validationSchema={schema}
    >
      {(formikProps) => {
        const { values = {}, setFieldValue = () => { } } = formikProps;
        return (
          <Form>
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
              <Row>
                <Checkbox name="isAllPosition"
                  checked={values?.isAllPosition === 'N'}
                  onChange={(e) => {
                    console.log('values?.isAllPosition', values?.isAllPosition);

                    setFieldValue("isAllPosition", e.target.checked ? 'N' : 'Y');
                    setFieldValue("conditionByPosition", [])
                    setFieldValue("conditionForAllPosition.leavePermissionTime", {})
                  }}
                  disabled={type == 'view'}
                >
                  {t('leave_type.label.set-leave-entitlement-according-to-position-level')}
                </Checkbox>
              </Row>
              {values?.isAllPosition === 'N' ? (
                <FieldArray name="conditionByPosition">
                  {({ remove, push }) => (
                    <div className={styles.container}>
                      {values?.conditionByPosition.map((_, index1) => (
                        <div className="card" style={{ marginTop: "1%", }} >
                          <Row gutter={[24, 16]}>
                            <>
                              <Col span={10}>
                                <Select
                                  name={`conditionByPosition.${index1}.leavePermissionTime.positionId`}
                                  suffixIcon={<SearchOutlined />}
                                  placeholder={
                                    t("employee.label.position")
                                  }
                                  size="large"
                                  mode="multiple"
                                  tagRender={tagRender}

                                  options={positionOptions}
                                  disabled={type == 'view'}
                                />
                              </Col>
                              <Col span={2}>

                              </Col>
                              <Col span={8}>

                                <Col span={10}>
                                  <label>{t('leave_type.label.determine-by-work-experience')}  </label>
                                  <AntdSwitch
                                    name={`conditionByPosition.${index1}.leavePermissionTime.determineByWorkExp`}
                                    checked={values?.conditionByPosition?.[index1]?.leavePermissionTime?.determineByWorkExp === 'Y'}
                                    onChange={(e) => {
                                      console.log(values?.conditionByPosition?.[index1]?.leavePermissionTime?.determineByWorkExp);

                                      setFieldValue(`conditionByPosition.${index1}.leavePermissionTime.determineByWorkExp`, e === true ? 'Y' : 'N')
                                    }}
                                    // defaultValue='N'
                                    disabled={type == 'view'}
                                  />
                                </Col>
                              </Col>
                              {type == 'view' ? <Col span={2} style={{}}>
                                <DeleteOutlined onClick={() => {
                                  Modal.confirm({
                                    title: t("dialog.confirmation.header"),
                                    content: i18n.language === "en"
                                      ? <span>Are you sure you want to delete?</span>
                                      : <span>คุณยืนยันการลบใช่หรือไม่?</span>,
                                    okText: t("common.confirm"),
                                    cancelText: t("common.cancel"),
                                    onOk: async () => {
                                      await remove([index1]);
                                      return Promise.resolve();
                                    }
                                  });
                                }} />
                              </Col> : null}
                            </>

                          </Row>
                          <Divider />

                          {values?.conditionByPosition?.[index1]?.leavePermissionTime?.determineByWorkExp === 'Y' ? (
                            <FieldArray name={`conditionByPosition.${index1}.leavePermissionTime.durationTime`}>
                              {({ remove, push }) => (
                                <div style={{ marginTop: "1%" }}>
                                  {values?.conditionByPosition?.[index1]?.leavePermissionTime?.durationTime?.map((_, index2) => (
                                    <Row gutter={[24, 16]}>
                                      <Col span={3}>
                                        <InputNumber
                                          name={`conditionByPosition.${index1}.leavePermissionTime.durationTime.${index2}.haveWorkFor`}
                                          size="middle"
                                          min={0}
                                          precision={0}
                                          label={t('leave_type.label.have-work-for')}
                                          controls={false}
                                          disabled={type == 'view'}
                                          textAlign="left"
                                        />
                                      </Col>
                                      <Col span={3}>
                                        <Field as={RadioGroup} onChange={(e) => {
                                          setFieldValue(`conditionByPosition.${index1}.leavePermissionTime.durationTime.${index2}.haveWorkForUnit`, e)
                                        }}

                                          name={`conditionByPosition.${index1}.leavePermissionTime.durationTime.${index2}.haveWorkForUnit`}
                                          buttonStyle="solid"
                                          optionType="button"
                                          label={t('leave_type.label.unit')}
                                          value={values?.conditionByPosition?.[index1]?.leavePermissionTime?.durationTime?.[index2]?.haveWorkForUnit}
                                          options={[
                                            {
                                              label: t('payroll_period.label.month'),
                                              value: "MONTHS",
                                            },
                                            {
                                              label: t('translation.year'),
                                              value: "YEARS",
                                            },

                                          ]}
                                          disabled={type == 'view'}
                                        />
                                      </Col>
                                      <Col span={3}>
                                        <InputNumber
                                          name={`conditionByPosition.${index1}.leavePermissionTime.durationTime.${index2}.butLessThan`}
                                          size="middle"
                                          min={0}
                                          precision={0}
                                          label={t('leave_type.label.but-less-than')}
                                          controls={false}
                                          textAlign="left"
                                        />
                                      </Col>
                                      <Col span={3}>
                                        <Field as={RadioGroup} onChange={(e) => setFieldValue(`conditionByPosition.${index1}.leavePermissionTime.durationTime.${index2}.butLessThanUnit`, e)}

                                          name={`conditionByPosition.${index1}.leavePermissionTime.durationTime.${index2}.butLessThanUnit`}
                                          buttonStyle="solid"
                                          optionType="button"
                                          label={t('leave_type.label.unit')}
                                          value={values?.conditionByPosition?.[index1]?.leavePermissionTime?.durationTime?.[index2]?.butLessThanUnit}
                                          options={[
                                            {
                                              label: t('payroll_period.label.month'),
                                              value: "MONTHS",
                                            },
                                            {
                                              label: t('translation.year'),
                                              value: "YEARS",
                                            },

                                          ]}
                                          disabled={type == 'view'}
                                        />
                                      </Col>
                                      <Col span={3}>
                                        <InputNumber name={`conditionByPosition.${index1}.leavePermissionTime.durationTime.${index2}.leaveDay`} controls={false}
                                          size="middle" min={0} label={t('leave_type.label.leave-day')} precision={0}
                                          disabled={values?.conditionByPosition?.[index1]?.leavePermissionTime?.durationTime?.[index2]?.unlimited === 'Y' ? true : false || type == 'view'}
                                          textAlign="left"
                                        />
                                      </Col>
                                      <Col span={3}>
                                        <InputNumber name={`conditionByPosition.${index1}.leavePermissionTime.durationTime.${index2}.leaveHour`}
                                          size="middle" min={0} label={t('leave_type.label.leave-hour')} controls={false} precision={0}
                                          disabled={values?.conditionByPosition?.[index1]?.leavePermissionTime?.durationTime?.[index2]?.unlimited === 'Y' ? true : false || type == 'view'}
                                          textAlign="left"
                                        />
                                      </Col>
                                      <Col span={2} >
                                        <label>
                                          {t('leave_type.label.unlimited')}
                                        </label>
                                        <Row >
                                          <Field as={Checkbox} name={`conditionByPosition.${index1}.leavePermissionTime.durationTime.${index2}.unlimited`}
                                            label={t('leave_type.label.unlimited')}
                                            checked={values?.conditionByPosition?.[index1]?.leavePermissionTime?.durationTime?.[index2]?.unlimited === 'Y'}
                                            onChange={(e) => {
                                              setFieldValue(`conditionByPosition.${index1}.leavePermissionTime.durationTime.${index2}.unlimited`, e.target.checked ? 'Y' : 'N');
                                            }}
                                            disabled={type == 'view'}
                                          />

                                        </Row>
                                      </Col>
                                      <Col span={2}>
                                        <Row>
                                          <label>
                                            {t('leave_type.label.prorate')}</label></Row>
                                        <Row>
                                          <Field as={Checkbox} name={`conditionByPosition.${index1}.leavePermissionTime.durationTime.${index2}.prorate`}
                                            label={t('leave_type.label.prorate')}
                                            checked={values?.conditionByPosition?.[index1]?.leavePermissionTime?.durationTime?.[index2]?.prorate === 'Y'}
                                            disabled={values?.conditionByPosition?.[index1]?.leavePermissionTime?.durationTime?.[index2]?.unlimited === 'Y' ? true : false || type == 'view'}
                                            onChange={(e) => {
                                              setFieldValue(`conditionByPosition.${index1}.leavePermissionTime.durationTime.${index2}.prorate`, e.target.checked ? 'Y' : 'N');
                                            }}
                                          />
                                        </Row>
                                      </Col>
                                      {(type !== 'view') ? <Col span={2} style={{ alignContent: "center", paddingTop: "4vh" }}>
                                        <DeleteOutlined onClick={() => remove(index2)} />
                                      </Col> : null}
                                    </Row>))}
                                  {(type !== 'view') ? <ConfigProvider wave={{ disabled: true }}>
                                    <Button
                                      className={styles.buttonAdd}
                                      onClick={() => push(
                                        // { id: '' }
                                      )}

                                    >
                                      <PlusCircleOutlined />
                                      <span>{t('leave_type.label.add')}</span>
                                    </Button>
                                  </ConfigProvider> : null}
                                </div>)}
                            </FieldArray>
                          ) : (
                            <Row gutter={[24, 16]}>
                              <Col span={3}>
                                <InputNumber
                                  name={`conditionByPosition.${index1}.leavePermissionTime.durationTime.leaveDay`}
                                  size="middle"
                                  min={0}
                                  precision={0}
                                  label={t('leave_type.label.leave-day')}
                                  controls={false}
                                  disabled={values?.conditionByPosition?.[index1]?.leavePermissionTime?.durationTime?.[0]?.unlimited === 'Y' ? true : false || type == 'view'}
                                  textAlign="left"
                                />
                              </Col>
                              <Col span={3}>
                                <InputNumber
                                  name={`conditionByPosition.${index1}.leavePermissionTime.durationTime.${0}.leaveHour`}
                                  size="middle"
                                  min={0}
                                  precision={0}
                                  label={t('leave_type.label.leave-hour')}
                                  controls={false}
                                  disabled={values?.conditionByPosition?.[index1]?.leavePermissionTime?.durationTime?.[0]?.unlimited === 'Y' ? true : false || type == 'view'}
                                  textAlign="left"
                                />
                              </Col>
                              <Col span={2}>
                                <label>
                                  {t('leave_type.label.unlimited')}
                                </label>
                                <Row>
                                  <Field as={Checkbox} name={`conditionByPosition.${index1}.leavePermissionTime.durationTime.${0}.unlimited`}
                                    label={t('leave_type.label.unlimited')}
                                    checked={values?.conditionByPosition?.[index1]?.leavePermissionTime?.durationTime?.[0]?.unlimited === 'Y'}
                                    onChange={(e) => {
                                      // handledaysForMultiplying(e)
                                      setFieldValue(`conditionByPosition.${index1}.leavePermissionTime.durationTime.${0}.unlimited`, e.target.checked ? 'Y' : 'N');
                                    }}
                                    disabled={type == 'view'}
                                  />

                                </Row>
                              </Col>
                              <Col span={2}>
                                <Row>
                                  <label>
                                    {t('leave_type.label.prorate')}</label></Row>
                                <Row>
                                  <Field as={Checkbox} name={`conditionByPosition.${index1}.leavePermissionTime.durationTime.${0}.prorate`}
                                    label={t('leave_type.label.prorate')}
                                    checked={values?.conditionByPosition?.[index1]?.leavePermissionTime?.durationTime?.[0]?.prorate === 'Y'}
                                    disabled={values?.conditionByPosition?.[index1]?.leavePermissionTime?.durationTime?.[0]?.unlimited === 'Y' ? true : false || type == 'view'}
                                    onChange={(e) => {
                                      setFieldValue(`conditionByPosition.${index1}.leavePermissionTime.durationTime.${0}.prorate`, e.target.checked ? 'Y' : 'N');
                                    }}
                                  />
                                </Row>
                              </Col>
                            </Row>
                          )}
                        </div>
                      ))}
                      {(type !== 'view') ? <ConfigProvider wave={{ disabled: true }}>
                        <Button
                          className={styles.buttonAdd}
                          onClick={() => push({
                            // id: '' 
                          })}

                        >
                          <PlusCircleOutlined />
                          <span>{t('leave_type.label.add_condition')}</span>
                        </Button>
                      </ConfigProvider> : null}

                    </div>)}
                </FieldArray>) :

                (
                  <div className="card" style={{ marginTop: "1%", }} >
                    <Row gutter={[24, 16]}>
                      <>
                        <Col span={14}>
                          <label>{t('leave_type.label.for-all-positions')}</label>

                        </Col>

                        <Col span={10}>
                          <label>{t('leave_type.label.determine-by-work-experience')}  </label>
                          <AntdSwitch
                            name={`conditionForAllPosition.leavePermissionTime.determineByWorkExp`}
                            // values={values?.conditionForAllPosition?.leavePermissionTime?.determineByWorkExp === 'Y'}
                            checked={values?.conditionForAllPosition?.leavePermissionTime?.determineByWorkExp === 'Y'}
                            onChange={(e) => {


                              setFieldValue('conditionForAllPosition.leavePermissionTime.determineByWorkExp', e === true ? 'Y' : 'N')
                              console.log('determineByWorkExp', values?.conditionForAllPosition?.leavePermissionTime?.determineByWorkExp);
                            }}
                            disabled={type == 'view'}
                          />
                        </Col>
                      </>
                    </Row>
                    <Divider />

                    {/*Not Determine By Work Experience*/}
                    {values?.conditionForAllPosition?.leavePermissionTime?.determineByWorkExp === "N" || !values?.conditionForAllPosition?.leavePermissionTime?.determineByWorkExp ? (
                      <Row gutter={[24, 16]}>
                        <Col span={3}>
                          <InputNumber
                            name={`conditionForAllPosition.leavePermissionTime.durationTime.${0}.leaveDay`}
                            size="middle"
                            min={0}
                            precision={0}
                            label={t('leave_type.label.leave-day')}
                            controls={false}
                            textAlign="left"
                            disabled={values?.conditionForAllPosition?.leavePermissionTime?.durationTime?.[0]?.unlimited === 'Y' ? true : false || type == 'view'}
                          />
                        </Col>
                        <Col span={3}>
                          <InputNumber name={`conditionForAllPosition.leavePermissionTime.durationTime.${0}.leaveHour`}
                            size="middle" min={0} label={t('leave_type.label.leave-hour')} controls={false}
                            precision={0}
                            disabled={values?.conditionForAllPosition?.leavePermissionTime?.durationTime?.[0]?.unlimited === 'Y' ? true : false || type == 'view'}
                            textAlign="left"
                          />
                        </Col>
                        <Col span={2}>
                          <label>
                            {t('leave_type.label.unlimited')}
                          </label>
                          <Row>
                            <Field as={Checkbox} name={`conditionForAllPosition.leavePermissionTime.durationTime.${0}.unlimited`}
                              label={t('leave_type.label.unlimited')}
                              checked={values?.conditionForAllPosition?.leavePermissionTime?.durationTime?.[0]?.unlimited === 'Y'}
                              onChange={(e) => {
                                // handledaysForMultiplying(e)
                                setFieldValue(`conditionForAllPosition.leavePermissionTime.durationTime.${0}.unlimited`, e.target.checked ? 'Y' : 'N');
                              }}
                              disabled={type == 'view'}
                            />

                          </Row>
                        </Col>
                        <Col span={2}>
                          <Row>
                            <label>
                              {t('leave_type.label.prorate')}</label></Row>
                          <Row>
                            <Field as={Checkbox} name={`conditionForAllPosition.leavePermissionTime.durationTime.${0}.prorate`}
                              label={t('leave_type.label.prorate')}
                              checked={values?.conditionForAllPosition?.leavePermissionTime?.durationTime?.[0]?.prorate === 'Y'}
                              disabled={values?.conditionForAllPosition?.leavePermissionTime?.durationTime?.[0]?.unlimited === 'Y' ? true : false || type == 'view'}
                              onChange={(e) => {
                                // handledaysForMultiplying(e)
                                setFieldValue(`conditionForAllPosition.leavePermissionTime.durationTime.${0}.prorate`, e.target.checked ? 'Y' : 'N');
                              }}
                            />
                          </Row>
                        </Col>
                      </Row>
                    ) : (
                      /*Determine By Work Experience*/
                      <FieldArray name={`conditionForAllPosition.leavePermissionTime.durationTime`}>
                        {({ remove, push }) => (
                          <div style={{ marginTop: "1%" }}>
                            {values?.conditionForAllPosition?.leavePermissionTime?.durationTime?.map((_, index) => (
                              <Row gutter={[24, 16]}>
                                <Col span={3}>
                                  <InputNumber
                                    name={`conditionForAllPosition.leavePermissionTime.durationTime.${index}.haveWorkFor`}
                                    size="middle"
                                    min={0}
                                    precision={0}
                                    label={t('leave_type.label.have-work-for')}
                                    disabled={type == 'view'}
                                    controls={false}
                                    textAlign="left"
                                  />
                                </Col><Col span={3}>
                                  <Field as={RadioGroup} onChange={(e) => {
                                    setFieldValue(`conditionForAllPosition.leavePermissionTime.durationTime.${index}.haveWorkForUnit`, e)
                                  }}
                                    name={`conditionForAllPosition.leavePermissionTime.durationTime.${index}.haveWorkForUnit`}
                                    buttonStyle="solid"
                                    optionType="button"
                                    label={t('leave_type.label.unit')}
                                    value={values?.conditionForAllPosition?.leavePermissionTime?.durationTime?.[index]?.haveWorkForUnit}
                                    options={[
                                      {
                                        label: t('payroll_period.label.month'),
                                        value: "MONTHS",
                                      },
                                      {
                                        label: t('translation.year'),
                                        value: "YEARS",
                                      },

                                    ]}
                                    disabled={type == 'view'}
                                  />
                                </Col>
                                <Col span={3}>
                                  <InputNumber
                                    name={`conditionForAllPosition.leavePermissionTime.durationTime.${index}.butLessThan`}
                                    size="middle"
                                    min={0}
                                    precision={0}
                                    label={t('leave_type.label.but-less-than')}
                                    disabled={type == 'view'}
                                    controls={false}
                                    textAlign="left"
                                  />
                                </Col><Col span={3}>
                                  <Field as={RadioGroup} onChange={(e) => setFieldValue(`conditionForAllPosition.leavePermissionTime.durationTime.${index}.butLessThanUnit`, e)}
                                    required={true}
                                    disabled={type == 'view'}
                                    name={`conditionForAllPosition.leavePermissionTime.durationTime.${index}.butLessThanUnit`}
                                    buttonStyle="solid"
                                    optionType="button"
                                    label={t('leave_type.label.unit')}
                                    value={values?.conditionForAllPosition?.leavePermissionTime?.durationTime?.[index]?.butLessThanUnit}
                                    options={[
                                      {
                                        label: t('payroll_period.label.month'),
                                        value: "MONTHS",
                                      },
                                      {
                                        label: t('translation.year'),
                                        value: "YEARS",
                                      },

                                    ]}
                                  />
                                </Col>
                                <Col span={3}>
                                  <InputNumber name={`conditionForAllPosition.leavePermissionTime.durationTime.${index}.leaveDay`}
                                    size="middle"
                                    min={0}
                                    label={t('leave_type.label.leave-day')}
                                    controls={false}
                                    disabled={values?.conditionForAllPosition?.leavePermissionTime?.durationTime?.[index]?.unlimited === 'Y' ? true : false || type == 'view'}
                                    precision={0}
                                    textAlign="left"
                                  />
                                </Col>
                                <Col span={3}>
                                  <InputNumber
                                    name={`conditionForAllPosition.leavePermissionTime.durationTime.${index}.leaveHour`}
                                    size="middle"
                                    min={0}
                                    precision={0}
                                    label={t('leave_type.label.leave-hour')}
                                    controls={false}
                                    disabled={values?.conditionForAllPosition?.leavePermissionTime?.durationTime?.[index]?.unlimited === 'Y' ? true : false || type == 'view'}
                                    textAlign="left" />
                                </Col>
                                <Col span={2}>
                                  <label>
                                    {t('leave_type.label.unlimited')}
                                  </label>
                                  <Row>
                                    <Field as={Checkbox} name={`conditionForAllPosition.leavePermissionTime.durationTime.${index}.unlimited`}
                                      label={t('leave_type.label.unlimited')}
                                      checked={values?.conditionForAllPosition?.leavePermissionTime?.durationTime?.[index]?.unlimited === 'Y'}
                                      onChange={(e) => {
                                        // handledaysForMultiplying(e)
                                        setFieldValue(`conditionForAllPosition.leavePermissionTime.durationTime.${index}.unlimited`, e.target.checked ? 'Y' : 'N');
                                      }}
                                      disabled={type == 'view'}
                                    />

                                  </Row>
                                </Col>
                                <Col span={2}>
                                  <Row>
                                    <label>
                                      {t('leave_type.label.prorate')}</label></Row>
                                  <Row>
                                    <Field as={Checkbox} name={`conditionForAllPosition.leavePermissionTime.durationTime.${index}.prorate`}
                                      label={t('leave_type.label.prorate')}
                                      checked={values?.conditionForAllPosition?.leavePermissionTime?.durationTime?.[index]?.prorate === 'Y'}
                                      disabled={values?.conditionForAllPosition?.leavePermissionTime?.durationTime?.[index]?.unlimited === 'Y' ? true : false || type == 'view'}
                                      onChange={(e) => {
                                        // handledaysForMultiplying(e)
                                        setFieldValue(`conditionForAllPosition.leavePermissionTime.durationTime.${index}.prorate`, e.target.checked ? 'Y' : 'N');
                                      }}
                                    />
                                  </Row>
                                </Col>
                                {roles.includes("DELETE_CONFIGURATION|ATTENDANCE_SETTING|LEAVE_TYPE") && type !== 'view' && (
                                  <Col span={2} style={{ alignContent: "center", paddingTop: "4vh" }}>
                                    <DeleteOutlined onClick={() => {
                                      Modal.confirm({
                                        title: t("dialog.confirmation.header"),
                                        content: i18n.language === "en"
                                          ? <span>Are you sure you want to delete?</span>
                                          : <span>คุณยืนยันการลบใช่หรือไม่?</span>,
                                        okText: t("common.confirm"),
                                        cancelText: t("common.cancel"),
                                        onOk: async () => {
                                          await remove([index]);
                                          return Promise.resolve();
                                        }
                                      });
                                    }} />
                                  </Col>
                                )}
                              </Row>))}
                            {(type !== 'view') ?
                              <ConfigProvider wave={{ disabled: true }}>
                                <Button
                                  className={styles.buttonAdd}
                                  onClick={() => push(
                                    // { id: '' }
                                  )}

                                >
                                  <PlusCircleOutlined />
                                  <span>{t('leave_type.label.add')}</span>
                                </Button>
                              </ConfigProvider> : null}
                          </div>)}
                      </FieldArray>
                    )}

                  </div>
                )}


              <div>
                <Row justify="end" style={{ paddingTop: "24px" }}>
                  <Space size={24}>
                    <Button type="default" onClick={onCancel} size="large">
                      {t(type == 'view' === true ? "common.confirm" : "common.cancel").toUpperCase()}
                    </Button>
                    {(type !== 'view') === true ? <Button type="primary" htmlType="submit" size="large">
                      {t("common.submit").toUpperCase()}
                    </Button> : null}
                  </Space>
                </Row>
              </div>
            </Space>
          </Form>
        );
      }}
    </Formik >
  );
}

export default LeaveTypeEntitlementForm;
